// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.profile-container4 {
  padding: 20px;
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 800px;
  overflow-x: hidden; 
}

.bold{
  font-weight: bold;
}
.button-container4{
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
  padding: 0px 0rem 0 15rem;
  display: flex
;
  }
.db4{

  background-color:#474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 5px !important;
  display: block;
  margin-left: 6rem;
}
.bk4{

  background-color:#474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 5px;
  display: block;
  margin-left: -6rem;
}
@media (max-width: 768px) {
  .db4{
    padding-top: 0px !important;
    margin-left: 0px;
  }
  .button-container4 {
    padding: 0px;
  }
  .profile-container4{
    display: inline-block;
  }
  .bk4{
    margin-left: 0rem !important;
  }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    .db4{
      margin-left: 154px;
      text-wrap: nowrap;
      margin-top: 3rem;
    }
    .button-container4{
    
      margin-left: 0px;
      align-items: flex-start;
    }
    .bk4{
      margin-left: 0rem !important;
    }
  }

.profile-main4 {
  width: 100%;
  max-width: 800px;
  background-color: white;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  padding: 20px;
  padding-bottom: 0px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.profile-header {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  text-align: center;
}


.profile-info4 {
  display: flex;
  flex-wrap: wrap;
  /* gap: 10px;
  margin-left: 2rem; */
 
}

.profile-name {
  font-size: 28px;
  font-weight: bold;
  color: rgb(31, 110, 175);
  margin-bottom: 5px;
  text-transform: uppercase !important;
}
.jobtitle4 {
  display: inline-block; /* or display: block; */
}
.jobtitle4::first-letter{
  text-transform: uppercase !important;
}

.profile-detail4 {
  font-size: 14px;
  margin-top: 4px;
  color: #333;
  display: flex;
  align-items: center;
  word-break: break-word;
  text-wrap: wrap;
  text-align: justify;
}
.profile-detail4 .icon {
  margin-right: 8px;
}

.h34 {
  font-size: 20px;
  font-weight: 700;
  color: rgb(31, 110, 175);
}

.hr4 {
  border: none;
  height: 2px;
  background-color: rgb(31, 110, 175);
  margin: 8px 0;
}
.bold-title4 {
  font-weight: bold;
}
.hr-4{
  margin: 4px 0;
  border: none;
  border-bottom: 1px solid white;
}

.pt4{
  font-size: 14px;
  text-wrap: wrap;
  text-align: justify;
  margin-bottom: 1px;
}
ul {
  padding-left: 0px;
  font-size: 14px;
  font-weight: normal;
}
.col34{
  margin-right: 30px;
}
.Profile_img4 {
  width: 150px;
  height: 160px;
  object-fit: cover; 
}

.scroll-container4 {
  overflow-x: auto; 
  white-space: nowrap; 
  width: 100%; 

}

@media (max-width: 768px) {
  .profile-container4 {
    padding: 10px;
  }
  .scroll-container4 {
    overflow-x: auto; /* Maintain horizontal scroll for smaller screens */
  }

  .profile-main4 {
    padding: 15px;
  }

  .profile-header {
    align-items: center; 
    text-align: center;
  }
  .profile-name {
    font-size: 28px;
  }

  .profile-detail4 {
    font-size: 14px;
  }

  h3 {
    font-size: 18px;
  }
}

@media (max-width: 576px) {
  .profile-name {
    font-size: 28px;
  }

  .profile-detail4 {
    font-size: 14px;
  }
    .scroll-container4 {
    overflow-x: auto;
    white-space: nowrap; 
  }

  h3 {
    font-size: 18px;
  }

  .profile-main4 {
    box-shadow: none;
  }
}

@media (max-width: 400px) {
  .profile-header {
    gap: 10px;
  }

  .profile-detail4 .icon {
    margin-right: 8px;
  }

  .pt4 {
    font-size: 14px;
  }
}


.footer4 {
  padding: 3px 0;
  margin-top: 20px;
  border-top: 1px solid #e9ecef;

}

.footer-text4 {
  font-size: 16px;
  color: #6c757d; 
  text-align: end;
  margin-right: 15px;
  margin-bottom: 2px;
}

.footer-link4 {
  color: #007bff;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Resume/Template/UseTemp4.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB;AACF;EACE;AACF;;EAEE,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,qBAAqB;EACvB;EACA;IACE,4BAA4B;EAC9B;EACA;;EAEA;IACE;MACE,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;IACA;;MAEE,gBAAgB;MAChB,uBAAuB;IACzB;IACA;MACE,4BAA4B;IAC9B;EACF;;AAEF;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,eAAe;EACf;sBACoB;;AAEtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,qBAAqB,EAAE,uBAAuB;AAChD;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;;AAEb;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,gBAAgB,EAAE,mDAAmD;EACvE;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;IACE;IACA,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;;AAE/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB","sourcesContent":["\r\n.profile-container4 {\r\n  padding: 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n  width: 100%;\r\n  min-width: 800px;\r\n  overflow-x: hidden; \r\n}\r\n\r\n.bold{\r\n  font-weight: bold;\r\n}\r\n.button-container4{\r\n  width: 100%;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 10px 0;\r\n  padding: 0px 0rem 0 15rem;\r\n  display: flex\r\n;\r\n  }\r\n.db4{\r\n\r\n  background-color:#474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 5px !important;\r\n  display: block;\r\n  margin-left: 6rem;\r\n}\r\n.bk4{\r\n\r\n  background-color:#474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 5px;\r\n  display: block;\r\n  margin-left: -6rem;\r\n}\r\n@media (max-width: 768px) {\r\n  .db4{\r\n    padding-top: 0px !important;\r\n    margin-left: 0px;\r\n  }\r\n  .button-container4 {\r\n    padding: 0px;\r\n  }\r\n  .profile-container4{\r\n    display: inline-block;\r\n  }\r\n  .bk4{\r\n    margin-left: 0rem !important;\r\n  }\r\n  }\r\n\r\n  @media (min-width: 768px) and (max-width: 1024px) {\r\n    .db4{\r\n      margin-left: 154px;\r\n      text-wrap: nowrap;\r\n      margin-top: 3rem;\r\n    }\r\n    .button-container4{\r\n    \r\n      margin-left: 0px;\r\n      align-items: flex-start;\r\n    }\r\n    .bk4{\r\n      margin-left: 0rem !important;\r\n    }\r\n  }\r\n\r\n.profile-main4 {\r\n  width: 100%;\r\n  max-width: 800px;\r\n  background-color: white;\r\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);\r\n  padding: 20px;\r\n  padding-bottom: 0px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n.profile-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n  flex-wrap: wrap;\r\n  text-align: center;\r\n}\r\n\r\n\r\n.profile-info4 {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  /* gap: 10px;\r\n  margin-left: 2rem; */\r\n \r\n}\r\n\r\n.profile-name {\r\n  font-size: 28px;\r\n  font-weight: bold;\r\n  color: rgb(31, 110, 175);\r\n  margin-bottom: 5px;\r\n  text-transform: uppercase !important;\r\n}\r\n.jobtitle4 {\r\n  display: inline-block; /* or display: block; */\r\n}\r\n.jobtitle4::first-letter{\r\n  text-transform: uppercase !important;\r\n}\r\n\r\n.profile-detail4 {\r\n  font-size: 14px;\r\n  margin-top: 4px;\r\n  color: #333;\r\n  display: flex;\r\n  align-items: center;\r\n  word-break: break-word;\r\n  text-wrap: wrap;\r\n  text-align: justify;\r\n}\r\n.profile-detail4 .icon {\r\n  margin-right: 8px;\r\n}\r\n\r\n.h34 {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: rgb(31, 110, 175);\r\n}\r\n\r\n.hr4 {\r\n  border: none;\r\n  height: 2px;\r\n  background-color: rgb(31, 110, 175);\r\n  margin: 8px 0;\r\n}\r\n.bold-title4 {\r\n  font-weight: bold;\r\n}\r\n.hr-4{\r\n  margin: 4px 0;\r\n  border: none;\r\n  border-bottom: 1px solid white;\r\n}\r\n\r\n.pt4{\r\n  font-size: 14px;\r\n  text-wrap: wrap;\r\n  text-align: justify;\r\n  margin-bottom: 1px;\r\n}\r\nul {\r\n  padding-left: 0px;\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n}\r\n.col34{\r\n  margin-right: 30px;\r\n}\r\n.Profile_img4 {\r\n  width: 150px;\r\n  height: 160px;\r\n  object-fit: cover; \r\n}\r\n\r\n.scroll-container4 {\r\n  overflow-x: auto; \r\n  white-space: nowrap; \r\n  width: 100%; \r\n\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .profile-container4 {\r\n    padding: 10px;\r\n  }\r\n  .scroll-container4 {\r\n    overflow-x: auto; /* Maintain horizontal scroll for smaller screens */\r\n  }\r\n\r\n  .profile-main4 {\r\n    padding: 15px;\r\n  }\r\n\r\n  .profile-header {\r\n    align-items: center; \r\n    text-align: center;\r\n  }\r\n  .profile-name {\r\n    font-size: 28px;\r\n  }\r\n\r\n  .profile-detail4 {\r\n    font-size: 14px;\r\n  }\r\n\r\n  h3 {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .profile-name {\r\n    font-size: 28px;\r\n  }\r\n\r\n  .profile-detail4 {\r\n    font-size: 14px;\r\n  }\r\n    .scroll-container4 {\r\n    overflow-x: auto;\r\n    white-space: nowrap; \r\n  }\r\n\r\n  h3 {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .profile-main4 {\r\n    box-shadow: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 400px) {\r\n  .profile-header {\r\n    gap: 10px;\r\n  }\r\n\r\n  .profile-detail4 .icon {\r\n    margin-right: 8px;\r\n  }\r\n\r\n  .pt4 {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n\r\n.footer4 {\r\n  padding: 3px 0;\r\n  margin-top: 20px;\r\n  border-top: 1px solid #e9ecef;\r\n\r\n}\r\n\r\n.footer-text4 {\r\n  font-size: 16px;\r\n  color: #6c757d; \r\n  text-align: end;\r\n  margin-right: 15px;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.footer-link4 {\r\n  color: #007bff;\r\n  text-decoration: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
